import {
  FETCH_SETTLEMENTS_REQUEST,
  FETCH_SETTLEMENTS_SUCCESS,
  FETCH_SETTLEMENTS_FAILURE,
} from "./actionTypes";

export const fetchSettlementsRequest = () => ({
  type: FETCH_SETTLEMENTS_REQUEST,
});

export const fetchSettlementsSuccess = (settlements) => ({
  type: FETCH_SETTLEMENTS_SUCCESS,
  payload: settlements,
});

export const fetchSettlementsFailure = (error) => ({
  type: FETCH_SETTLEMENTS_FAILURE,
  payload: error,
});
